import { createSlice } from '@reduxjs/toolkit';

const initialState = {
//    name: 'テスト遺言者',
//    age: '55',
//    address: '東京都千代田区千代田1-1',
//    date: '1985-01-01'
};

const slice = createSlice({
    name: 'testament',
    initialState,
    reducers: {
        setTestament: (state, action) => {
            return Object.assign({}, state, action.payload)
        },
        clearTestament: (state, action) => {
            return Object.assign({}, state, {testament: {}})
        },
    }
});


export default slice.reducer;

export const {
    setTestament,
    clearTestament,
} = slice.actions;
